module.exports = __webpack_public_path__ + "img/selectores_y_conmutadores.eddbe4b2.jpg";